import { Controller } from "stimulus"

// Rooster 5 (#1519): per weekdag een extra tijdblok tonen. Er staan een paar
// lege rijen klaar (verborgen); "Tijdblok toevoegen" toont de volgende en
// zet de cursor erin. Zonder JavaScript staan alle rijen open.
export default class extends Controller {
  static targets = ["rij", "knop", "leeg"]

  connect() {
    this.werkKnopBij()
  }

  voegToe() {
    const volgende = this.rijTargets.find((rij) => rij.hidden)
    if (!volgende) return
    volgende.hidden = false
    if (this.hasLeegTarget) this.leegTarget.hidden = true
    const veld = volgende.querySelector("input")
    if (veld) veld.focus()
    this.werkKnopBij()
  }

  werkKnopBij() {
    if (!this.hasKnopTarget) return
    this.knopTarget.hidden = !this.rijTargets.some((rij) => rij.hidden)
  }
}
